import {useSyncExternalStore} from 'react'

/**
 * Where the schedule's status group (StatusPath + its changes + history) is
 * shown: an element under the Schedule page's title, above the calendar.
 *
 * The group is built by SchedulerDropdown, which lives in the page toolbar —
 * outside the routed page, so no shared React parent or context reaches both.
 * The page registers its element here with a ref callback; the toolbar
 * subscribes and portals into it, and stops rendering it when the page (and
 * so the element) goes away — switching to Overview, for instance.
 */
let slot: HTMLElement | null = null
const listeners = new Set<() => void>()

export const setStatusSlot = (el: HTMLElement | null) => {
  if (el === slot) return
  slot = el
  listeners.forEach((l) => l())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useStatusSlot = () => useSyncExternalStore(subscribe, () => slot)
